export default "/static/build/reputation-status-safe.png";